module.exports = __webpack_public_path__ + "static/media/022-planet.4feb6762.svg";